'use strict'
//import Service from '../services/services'

/**
 * Model for component Home
 * @returns list of posts
 */

class Model {

    articles: any;

  constructor () {
    this.articles = {}
  }

  async setArticles () {    
    return;
  }
}

export default Model